import React, { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useWorkspace } from '@/context/WorkspaceContext';
import { useLang } from '@/context/LangContext';
import { auditActionLabel, auditEntityLabel } from '@/lib/auditLabels';

export default function Audit() {
    const { t, lang } = useLang();
    const { currentWorkspace } = useWorkspace();
    const [logs, setLogs] = useState([]);
    const [names, setNames] = useState({});

    useEffect(() => {
        if (!currentWorkspace) return;
        (async () => {
            const { data } = await supabase
                .from('audit_logs')
                .select('*')
                .eq('workspace_id', currentWorkspace.id)
                .order('created_at', { ascending: false })
                .limit(200);
            setLogs(data || []);
            const ids = Array.from(new Set((data || []).map(l => l.user_id).filter(Boolean)));
            if (ids.length) {
                const { data: profs } = await supabase.from('profiles').select('id,full_name,email').in('id', ids);
                setNames(Object.fromEntries((profs || []).map(p => [p.id, p.full_name || p.email])));
            }
        })();
    }, [currentWorkspace]);

    return (
        <div className="space-y-8">
            <div>
                <div className="eyebrow mb-2">Conformité</div>
                <h1 className="font-heading text-4xl">{t('audit.title')}</h1>
                <p className="text-foreground/70 mt-3">{t('audit.sub')}</p>
            </div>

            <div className="card-soft overflow-hidden">
                <table className="w-full">
                    <thead className="bg-surface-muted text-left">
                        <tr className="text-xs uppercase tracking-wider text-muted-foreground">
                            <th className="px-6 py-4 font-medium">{t('audit.action')}</th>
                            <th className="px-6 py-4 font-medium">{t('audit.entity')}</th>
                            <th className="px-6 py-4 font-medium">{t('audit.user')}</th>
                            <th className="px-6 py-4 font-medium">{t('audit.date')}</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-border">
                        {logs.length === 0 && (
                            <tr><td colSpan={4} className="px-6 py-12 text-center text-foreground/60" data-testid="audit-empty">{t('audit.empty')}</td></tr>
                        )}
                        {logs.map((l) => (
                            <tr key={l.id} className="hover:bg-surface-muted" data-testid={`audit-row-${l.id}`}>
                                <td className="px-6 py-3 text-sm">{auditActionLabel(l.action, lang)}</td>
                                <td className="px-6 py-3 text-foreground/80">{auditEntityLabel(l.entity_type, lang)}</td>
                                <td className="px-6 py-3 text-foreground/80 text-sm">{names[l.user_id] || l.user_id?.slice(0, 8) || '—'}</td>
                                <td className="px-6 py-3 text-foreground/70 text-sm">{new Date(l.created_at).toLocaleString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
